var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          on: { clear: _vm.clearSelect },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l([], function(item) {
        return _c("el-option", {
          key: item.value,
          attrs: {
            label: item.label,
            multiple: "",
            "collapse-tags": "",
            value: item.value
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "custom-tree__box",
          attrs: { slot: "empty" },
          slot: "empty"
        },
        [
          _vm.labelSelect
            ? _c(
                "div",
                { staticClass: "custom-tree__label-filter" },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.openPersonDialog.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("按组织标签筛选")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("sales-person-select-dialog", {
            attrs: {
              "label-options": _vm.innerLabelOptions,
              "selected-ids": _vm.checkedValues,
              title: "按组织标签筛选人员"
            },
            on: { confirm: _vm.onPersonConfirm },
            model: {
              value: _vm.personDialogVisible,
              callback: function($$v) {
                _vm.personDialogVisible = $$v
              },
              expression: "personDialogVisible"
            }
          }),
          _vm._v(" "),
          (_vm.items && _vm.items.length > 10) ||
          (_vm.showFilter && _vm.items && _vm.items.length > 0)
            ? _c(
                "el-input",
                {
                  staticClass: "custom-tree__search",
                  attrs: {
                    placeholder: "未显示全部选项，可筛选",
                    clearable: ""
                  },
                  on: { input: _vm.inputChange },
                  model: {
                    value: _vm.filterText,
                    callback: function($$v) {
                      _vm.filterText = $$v
                    },
                    expression: "filterText"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "prepend" },
                    slot: "prepend"
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.items && _vm.items.length
            ? [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      indeterminate: _vm.isIndeterminate,
                      disabled: _vm.readonly || _vm.disableList.length > 0
                    },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll"
                    }
                  },
                  [_vm._v(_vm._s(_vm.selectText))]
                ),
                _vm._v(" "),
                _c(
                  "el-checkbox-group",
                  {
                    attrs: { disabled: _vm.readonly },
                    on: { change: _vm.handleCheckedChange },
                    model: {
                      value: _vm.checkedValues,
                      callback: function($$v) {
                        _vm.checkedValues = $$v
                      },
                      expression: "checkedValues"
                    }
                  },
                  [
                    _vm.isLabelMode
                      ? _vm._l(_vm.labelGroupedOptions, function(g) {
                          return _c(
                            "div",
                            {
                              key: "g" + g.typeId,
                              staticClass: "ms-label-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ms-label-group-title" },
                                [
                                  _vm._v(_vm._s(g.typeName || "未分类")),
                                  _c(
                                    "span",
                                    { staticClass: "ms-label-group-count" },
                                    [_vm._v(_vm._s(g.items.length))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(g.items, function(item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item[_vm.props.id || _vm.props.value],
                                    attrs: {
                                      label: item[_vm.props.value],
                                      disabled: _vm.disableList.includes(
                                        item[_vm.props.value]
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ms-label-opt" },
                                      [
                                        _c("i", {
                                          staticClass: "ms-label-dot",
                                          style: {
                                            background: item.color || "#409EFF"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ms-label-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item[_vm.props.label] ||
                                                  item[_vm.props.value]
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        })
                      : _vm._l(_vm.options, function(item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item[_vm.props.id || _vm.props.value],
                              attrs: {
                                label: item[_vm.props.value],
                                disabled: _vm.disableList.includes(
                                  item[_vm.props.value]
                                )
                              }
                            },
                            [
                              _vm.props.disabledValue !== undefined
                                ? _c(
                                    "span",
                                    {
                                      class: {
                                        "custom-tree__delete": _vm.judgeDisableStatus(
                                          item
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item[_vm.props.label] ||
                                            item[_vm.props.value]
                                        )
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item[_vm.props.label] ||
                                          item[_vm.props.value]
                                      )
                                    )
                                  ])
                            ]
                          )
                        })
                  ],
                  2
                )
              ]
            : [
                _c("div", { staticClass: "center" }, [
                  _vm._v("\n        暂无数据\n      ")
                ])
              ]
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e8c59d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e8c59d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiSelect.vue
// module id = null
// module chunks = 